module.exports = __webpack_public_path__ + "static2023-4-17/img/send-rec.f4cbd3cf.png";